import React from 'react';
import s from './DriversCard.module.css';
import Button from '../Button/Button';
import { BiArrowToBottom } from 'react-icons/bi';

export default function DriversCard({ products }) {
  return (
    <div className={s.ProductContainer}>
      <ul className={s.ProductsList}>
        {products.map(({ id, img, title, description }) => (
          <li key={id} className={s.ProductCard}>
            <div>
              <img src={img} alt="" />
            </div>
            <h3 className={s.title}>{title}</h3>
            <p className={s.text}>{description}</p>
            <div className={s.Button}>
              <Button inverted={true} name={'Завантажити'} />
              <BiArrowToBottom className={s.downloadIcon} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
